import { OptionEnum } from '../components/messages/messages.enum';

export class DialogOption {
    public title: string = "";
    public icon: string = '';
    public value: number = 0;
    public type: OptionEnum = OptionEnum.Positive;
    public class: string = "";

    constructor(init?: Partial<DialogOption>) {
        Object.assign(this, init);
    }
}
